import { Card, Spinner, Table } from "reactstrap";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import styled from "styled-components";
import "./studentperformamance.css";
// import BarGraph from "Pages/BranchHealth/Student/BarGraph";
import BarChart from "utilFunctions/shared/BarChart";
import {
  BASE_URL,
  EXTERNAL_TESTPLAYER_URL,
} from "utilFunctions/Constants/urlConstants";
import { useContext, useEffect, useLayoutEffect, useRef } from "react";
import { ToastContextDispatch } from "Context/CommonContext";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { useInView } from "react-intersection-observer";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
export const RiskStyledDiv = styled<any>("div")`
  background-color: ${(props: any) => props.color};
  border-radius: 4px;
  padding: 4px;
  width: fit-content;
`;
export const RiskStyledDSpan = styled<any>("span")`
  color: ${(props: any) => props.color};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;
interface IBarTable {
  searchedFaculty?: any;
  mode?: string;
  tableloading?: any;
  tableData?: any;
  filterState?: any;
  barArray?: any;
  tableHeading?: any;
  barData?: any;
  barLabel?: any;
  avgData?: any;
  topperData?: any;
  isFilterLoading?: any;
  graphLoading?: any;
  externalUrl?: any;
  setExternalUrl?: any;
  setDiv1Height?: any;
  isOlympiad?: any;
  studentPSID?: any;
  hasLoading?: any;
  fetchData?: any;
  hasMore?: any;
  page?: any;
  setPage?: any;
  studentsStream?: any;
}
const BarTable = ({
  tableHeading,
  tableData,
  barData,
  avgData,
  topperData,
  barLabel,
  isFilterLoading,
  graphLoading,
  setExternalUrl,
  setDiv1Height,
  isOlympiad,
  studentPSID,
  hasLoading,
  fetchData,
  hasMore,
  page,
  setPage,
  studentsStream,
}: IBarTable) => {
  const div1Ref = useRef(null);
  const ToastDispatch = useContext(ToastContextDispatch);
  useLayoutEffect(() => {
    const handleHeightCalculation = () => {
      const id: any = document.getElementById("tableHeadingDiv");
      if (id && id.clientHeight) {
        setDiv1Height(id.clientHeight);
        console.log(id);
      }
    };
    const timeoutId = setTimeout(handleHeightCalculation, 0);
    return () => clearTimeout(timeoutId);
  }, [tableData]);

  useEffect(() => {
    if (page > 0) {
      fetchData(page);
    }
  }, [page]);

  const { ref, inView } = useInView({
    threshold: 0,
  });
  useEffect(() => {
    if (inView && hasMore && !hasLoading) {
      setPage((prevPage: any) => prevPage + 1);
    }
  }, [inView, hasMore, hasLoading]);
  const renderColumnItem = (item: any, column: any, index: number) => {
    let returnItem;
    if (column.value == "name") {
      returnItem = (
        <td
          ref={div1Ref}
          id={"testHeader" + index}
          className={`border text-center tableWidthFixed ${
            !isOlympiad &&
            item?.externalScheduleId &&
            item?.externalScheduleId != null
              ? "TestNameStyling"
              : "olmpTestNameStyling"
          }`}
          onClick={() => {
            !isOlympiad &&
            item?.externalScheduleId &&
            item?.externalScheduleId != null
              ? handletestClick(item)
              : console.error("Olympiad test- not applicable");
          }}
        >
          <strong
            className={
              !isOlympiad &&
              item?.externalScheduleId &&
              item?.externalScheduleId != null
                ? "TestNameStyling"
                : ""
            }
          >
            {item[column.value]}
          </strong>
        </td>
      );
    } else if (column.value == "time") {
      returnItem = <td className="border text-center">{item[column.value]}</td>;
    } else if (column.value == "score") {
      returnItem = (
        <td className="border text-center tableWidthFixed">
          <div className="w-100 d-flex justify-content-center">
            <strong>{item[column.value]}</strong>
            <span style={{ fontSize: "12px", paddingLeft: "2px" }}>
              /{item?.total}
            </span>
          </div>
        </td>
      );
    } else if (
      [
        "allIndiaRank",
        "stateRank",
        "branchRank",
        "batchRank",
        "categoryRank",
      ].includes(column.value)
    ) {
      returnItem = (
        <td className="border text-center tableWidthFixed">
          {item?.[column.value] &&
          item[column.value] != undefined &&
          item[column.value] != parseInt("-1") ? (
            <strong>{item[column.value]}</strong>
          ) : (
            "-"
          )}
        </td>
      );
    } else {
      returnItem = (
        <td className="border text-center tableWidthFixed">
          {item["subjects"] &&
          item["subjects"][column.value] &&
          item["subjects"][column.value]["score"] ? (
            <div className="w-100 d-flex justify-content-center">
              <strong>{item["subjects"][column.value]?.["score"]}</strong>
              <span style={{ fontSize: "12px", paddingLeft: "2px" }}>
                /{item["subjects"][column.value]?.["total"]}
              </span>
            </div>
          ) : (
            "NA"
          )}
        </td>
      );
    }
    return returnItem;
  };

  const handletestClick = (item: any) => {
    const testNameLinkClickEvent = {
      event: "ag_ui_click_test_name_link",
      TEST_ID: item?.externalScheduleId,
      SOURCE_MODULE: "student_performance",
    };
    console.log(
      "[GTM Track Event] ag_ui_click_test_name_link:",
      testNameLinkClickEvent
    );
    pushToDataLayerForGTM(testNameLinkClickEvent);
    const url =
      BASE_URL +
      EXTERNAL_TESTPLAYER_URL +
      "?user_id=" +
      studentPSID +
      "&external_schedule_id=" +
      item?.externalScheduleId;
    GetTestPlayerExternalUrl(url);
  };
  const { makeRequest: GetTestPlayerExternalUrl } = useGetApi(
    (data: any) => {
      if (data["data"] && data["data"] && data["data"]["result_url"]) {
        setExternalUrl(data["data"]["result_url"]);
      }
    },
    (error: any) => {
      if (error && error["message"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      }
    }
  );

  return (
    <div className="m-0 overflow-auto">
      <Card className="mb-0">
        <div className="tableFixHead">
          {tableData && tableData.length === 0 ? (
            <div className="mt-4 mb-8">
              <NoResultFoundSearch
                primaryMessage="No data present"
                secondaryMessage={
                  "There is either no data available or the system is currently in the process of syncing data."
                }
              >
                <NoDataFoundIcon />
              </NoResultFoundSearch>
            </div>
          ) : (
            <div className="d-flex flex-row mainContainerForGraphTable">
              <div className="d-flex flex-column">
                {isFilterLoading || graphLoading ? (
                  <div className="graphHeightBarLoader">
                    <Spinner color="info" />
                  </div>
                ) : (
                  <div className="graphHeightBarDV">
                    <BarChart
                      data={barData}
                      avgData={avgData}
                      topperData={topperData}
                      barLabel={barLabel}
                    />
                  </div>
                )}
                <Table
                  responsive
                  className="table table-hover tableSideHead tableBodyMain table-responsive-no-radius"
                >
                  <tbody>
                    {tableHeading.map((item: any, index: number) => (
                      <tr key={index} id="tableHeadingDiv">
                        {tableData.map((el: any, i: number) =>
                          renderColumnItem(el, item, i)
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              {graphLoading || studentsStream !== "SOE" ? null : (
                <div
                  ref={ref}
                  style={{ height: 20 }}
                  id={"hasMorePerformanceData"}
                  className="hasMorePerformanceDataStyle"
                >
                  {hasLoading && <Spinner color="info" />}
                </div>
              )}
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};
export default BarTable;
